import { atom } from 'jotai';

export const primaryInstanceAtom = atom<boolean>(false);
